// extracted by mini-css-extract-plugin
export default {"group":"PadsScreen_group__Tw9gs"};